export default __webpack_public_path__ + "assets/android-icon-192x192.d9a8185c66e599dfe1e7c5ef72d90891.png";